export default __webpack_public_path__ + "static/media/awesome_tick.99cb07ae.png";